import React from 'react';

// 品牌名稱。店面（遮陽棚＋門），代表這一行是公司／品牌。
const IconBrand = ({ onClick }) => {
	return (
		<div className='IconBrand' onClick={onClick}>
			<svg
				width='20'
				height='20'
				viewBox='0 0 24 24'
				fill='none'
				stroke='#333333'
				strokeWidth='1.6'
				strokeLinecap='round'
				strokeLinejoin='round'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path d='M4 9.5V20h16V9.5' />
				<path d='M3 9.5 4.6 4h14.8L21 9.5' />
				<path d='M9.5 20v-5.5h5V20' />
			</svg>
		</div>
	);
};

export default IconBrand;
